module.exports = __webpack_public_path__ + "static/media/image-576.3e9b030c.jpg";